import { render, staticRenderFns } from "./ModalAgendaWrapper.vue?vue&type=template&id=5a83e5e6&scoped=true&"
import script from "./ModalAgendaWrapper.vue?vue&type=script&lang=js&"
export * from "./ModalAgendaWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgendaWrapper.vue?vue&type=style&index=0&id=5a83e5e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a83e5e6",
  null
  
)

export default component.exports